//mui
import {
  Paper,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
} from "@mui/material";

//dayjs
import dayjs from "dayjs";

export default function CampaignData({ data }) {
  function createData(name, colon, data) {
    return { name, colon, data };
  }


  const key =
    data?.variables?.button?.[0] && Object.keys(data?.variables?.button?.[0]);

  let rows = [
    createData("Campaign Name", ":", data?.name),
    createData("Template Name ", ":", data?.template?.name),

    createData(
      "Credits Used",
      ":",
      data?.credits_used ? data?.credits_used : 0
    ),
    createData(
      "Scheduled at",
      ":",
      data?.schedule ? dayjs(data?.schedule).format("DD/MM/YYYY LT") : "Pending"
    ),
    createData(
      "Started Time",
      ":",
      data?.started_at
        ? dayjs(data?.started_at).format("DD/MM/YYYY LT")
        : "Pending"
    ),
    createData(
      "End Time",
      ":",
      data?.ended_at ? dayjs(data?.ended_at).format("DD/MM/YYYY LT") : "Pending"
    ),
    createData("Created By ", ":", data?.created_by?.name),
    createData(
      "Updated By",
      ":",
      data?.updated_by?.name ? data?.updated_by?.name : "-"
    ),
    ,
    // createData("Mobile Number", ":", data[0]?.customer?.mobile),
    // createData("DOB", ":", data[0]?.customer?.dob || "Not Mentioned"),
    // createData(
    //   "Nationality",
    //   ":",
    //   data[0]?.customer?.nationality || "Not Mentioned"
    // ),
    // createData("Email", ":", data[0]?.customer?.email || "Not Mentioned"),
  ];
  if (data?.variables?.button[0]?.[key?.[0]]) {
    rows.push(createData(
      "Action (CTA) Content",
      ":",
      data?.variables?.button[0]?.[key?.[0]]
    ))
  }
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "fix-content",
        boxShadow: "none",
        maxWidth: { xs: 300, sm: 500 },
      }}
    >
      <Table sx={{ tableLayout: "auto" }} aria-label="simple table">
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              sx={{ "& td, & th": { border: 0, height: "30px" } }}
            >
              <TableCell
                width="150px"
                sx={{ padding: "0px 5px", minWidth: "160px" }}
              >
                {" "}
                <Typography variant="body2">{row.name}</Typography>
              </TableCell>
              <TableCell width={5} sx={{ padding: "0px 5px" }}>
                <Typography variant="subtitle2">{row.colon}</Typography>
              </TableCell>
              <TableCell sx={{ padding: "0px 5px" }}>
                <Typography variant="subtitle2">{row.data}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
